import { render, staticRenderFns } from "./AdminQuestionList.vue?vue&type=template&id=aba6dda2&scoped=true"
import script from "./AdminQuestionList.vue?vue&type=script&lang=js"
export * from "./AdminQuestionList.vue?vue&type=script&lang=js"
import style0 from "./AdminQuestionList.vue?vue&type=style&index=0&id=aba6dda2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba6dda2",
  null
  
)

export default component.exports